export default "__VITE_ASSET__BNxuNZ3G__"